import { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function AdminDashboard() {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    axios.get("https://spotcommglobal.com/admin/getBlogs.php").then(res => {
      const titles = res.data.map(b => b.title);
      const views = res.data.map(b => b.views);
      setChartData({
        labels: titles,
        datasets: [{
          label: 'Blog Views',
          data: views,
          backgroundColor: 'rgba(75,192,192,0.6)',
        }]
      });
    });
  }, []);

  return (
    <div>
      <h2>Blog Views Chart</h2>
      {chartData && <Bar data={chartData} />}
    </div>
  );
}

export default AdminDashboard;
